<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">拓客利器</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">快商宝</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="vistor-content">
            <div class="search-vistor-content">
                <div class="single-search">
                    <a-input-search placeholder="输入企业、经营范围、地址、产品名称" v-model="searchname" style="width: 200px" @search="onSearch" />
                    <a-checkbox @change="onChange" defalut-checked>按名称</a-checkbox>
                    <a-checkbox @change="onChange">按地址</a-checkbox>
                    <a-checkbox @change="onChange">按产品</a-checkbox>
                    <a-checkbox @change="onChange">按经营范围</a-checkbox>
                </div>

                <div class="multiple-search">
                    <div class="save-search">
                        <a-icon type="star" />
                        <span>保存筛选条件</span>
                    </div>

                    <div class="serach-list">
                        <div class="serach-area">
                            <div class="title">地区</div>
                            <div class="area-list">
                                <span @click="selectaddress(item,i)" :class="{optioned:i==currented}" v-for="(item,i) in addreslist" :key="i">{{item}}</span>
                                <!-- <a href="javascript:;">更多城市</a> -->
                                <a-popover placement="leftTop">
                                    <template slot="content">
                                        <!-- <vue-area-select isShow></vue-area-select> -->
                                    </template>
                                    <!-- <a href="javascript:;">更多城市</a> -->
                                </a-popover>
                            </div>
                        </div>

                        <div class="search-hy">
                            <div class="title">行业</div>
                            <div class="hy-list">
                                <a-row>
                                    <a-radio-group @change="onChangehx" v-model="hy">
                                        <a-col :span="24">
                                            <section><a-radio value="">不限</a-radio></section>
                                            <section><a-radio value="农林牧业">农林牧业</a-radio></section>
                                            <section><a-radio value="采矿业">采矿业</a-radio></section>
                                            <section><a-radio value="制造业">制造业</a-radio></section>
                                            <section><a-radio value="水电燃气">水电燃气</a-radio></section>
                                            <section><a-radio value="建筑业">建筑业</a-radio></section>
                                            <section><a-radio value="批发零售">批发零售</a-radio></section>
                                        </a-col>
                                        <a-col :span="24">
                                            <section><a-radio value="住宿餐饮">住宿餐饮</a-radio></section>
                                            <section><a-radio value="互联网">互联网</a-radio></section>
                                            <section><a-radio value="金融业">金融业</a-radio></section>
                                            <section><a-radio value="房地产业">房地产业</a-radio></section>
                                            <section><a-radio value="商业服务">商业服务</a-radio></section>
                                            <section><a-radio value="科技服务">科技服务</a-radio></section>
                                            <section><a-radio value="水利公共">水利公共</a-radio></section>
                                        </a-col>
                                        <a-col :span="24">
                                            <section><a-radio value="交通运输">交通运输</a-radio></section>
                                            <section><a-radio value="居民服务">居民服务</a-radio></section>
                                            <section><a-radio value="教育">教育</a-radio></section>
                                            <section><a-radio value="公共卫生">公共卫生</a-radio></section>
                                            <section><a-radio value="文体娱乐">文体娱乐</a-radio></section>
                                            <section><a-radio value="公共机构">公共机构</a-radio></section>
                                            <section><a-radio value="国际组织">国际组织</a-radio></section>
                                        </a-col>
                                    </a-radio-group>
                                </a-row>
                            </div>
                            <div class="right">
                                <span>展开<a-icon type="down" /></span>
                            </div>
                        </div>

                        <div class="search-hy">
                            <div class="title">企业类型</div>
                            <div class="hy-list">
                                <a-row>
                                    <a-radio-group @change="onChangeqy" v-model="qy">
                                        <a-col :span="24">
                                            <section><a-radio value="">不限</a-radio></section>
                                            <section><a-radio value="有限责任公司">有限责任公司</a-radio></section>
                                            <section><a-radio value="股份有限公司">股份有限公司</a-radio></section>
                                            <section><a-radio value="国企">国企</a-radio></section>
                                            <section><a-radio value="外商投资企业">外商投资企业</a-radio></section>
                                            <section><a-radio value="个人独资企业">个人独资企业</a-radio></section>
                                            <section><a-radio value="有限合伙">有限合伙</a-radio></section>
                                        </a-col>
                                        <a-col :span="24">
                                            <section><a-radio value="普通合伙">普通合伙</a-radio></section>
                                            <section><a-radio value="个体工商户">个体工商户</a-radio></section>
                                            <section><a-radio value="联营企业">联营企业</a-radio></section>
                                            <section><a-radio value="集体所有制">集体所有制</a-radio></section>
                                            <section><a-radio value="其他">其他</a-radio></section>
                                        </a-col>
                                    </a-radio-group>
                                </a-row>
                            </div>
                            <div class="right">
                                <span>展开<a-icon type="down" /></span>
                            </div>
                        </div>

                        <div class="search-hy">
                            <div class="title">注册资本</div>
                            <div class="hy-list">
                                <a-row>
                                    <a-col :span="24">
                                        <a-radio-group @change="onChangezb" v-model="zb">
                                            <section><a-radio value="">不限</a-radio></section>
                                            <section><a-radio value="1">100万以内</a-radio></section>
                                            <section><a-radio value="12">100万-200万</a-radio></section>
                                            <section><a-radio value="3">200万-500万</a-radio></section>
                                            <section><a-radio value="4">500万-1000万</a-radio></section>
                                            <section><a-radio value="5">1000万-5000万</a-radio></section>
                                            <section><a-radio value="6">5000万以上</a-radio></section>
                                        </a-radio-group>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>

                        <div class="search-hy">
                            <div class="title">企业状态</div>
                            <div class="hy-list">
                                <a-row>
                                    <a-col :span="24">
                                        <a-radio-group @change="onChangezt" v-model="zt">
                                            <section><a-radio value="">不限</a-radio></section>
                                            <section><a-radio value="1">在业</a-radio></section>
                                            <section><a-radio value="8">存续</a-radio></section>
                                            <section><a-radio value="2">注销</a-radio></section>
                                            <section><a-radio value="3">吊销</a-radio></section>
                                            <section><a-radio value="4">撤销</a-radio></section>
                                            <section><a-radio value="5">迁出</a-radio></section>
                                            <section><a-radio value="6">停业</a-radio></section>
                                            <section><a-radio value="7">其他</a-radio></section>
                                        </a-radio-group>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>

                        <div class="search-hy">
                            <div class="title">成立年限</div>
                            <div class="hy-list">
                                <a-row>
                                    <a-col :span="24">
                                        <a-radio-group @change="onChangenx" v-model="nx">
                                            <section><a-radio value="">不限</a-radio></section>
                                            <section><a-radio value="1">1年内</a-radio></section>
                                            <section><a-radio value="2">1-2年</a-radio></section>
                                            <section><a-radio value="3">2-3年</a-radio></section>
                                            <section><a-radio value="4">3-5年</a-radio></section>
                                            <section><a-radio value="5">5-10年</a-radio></section>
                                            <section><a-radio value="6">10年以上</a-radio></section>
                                        </a-radio-group>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>

            <div class="tj-company" v-for="item in companylist" :key="item._source.id" @click="showDrawer(item._source.id)">
                <div class="company-list" style="width: 100%" >
                    <a-card size="small" title="推荐企业" style="width: 100%">
                    <!-- <a slot="extra" href="#"><a-icon type="redo" />换一批</a> -->
                        <div class="company-info"  @click="showDrawer">
                           <div class="lq-phone">
                               <a-button type="primary" @click="receivephone(item._source.id)">立即领取</a-button>
                               <p>手机号{{item._source.total_phone_num}}条</p>
                           </div>
                            <div class="company-head">
                                <img src="../../../static/head.jpg" alt="">
                            </div>
                            <div class="info">
                               <h3>{{item._source.name}}</h3>
                               <section class="type">
                                   <span>联系方式{{item._source.total_contact_num}}个</span>
                                   <!-- <span>制造业</span> -->
                                   <span>{{item._source.status}}</span>
                                   <!-- <span>有商标</span> -->
                               </section>
                               <section class="cz">
                                   <span>
                                       <span>法定代表:</span>
                                       <span>{{item._source.legal}}</span>
                                       <span class="block"></span>
                                   </span>
                                   <span>
                                       <span>注册资本:</span>
                                       <span>{{item._source.registermoney}}</span>
                                       <span class="block"></span>
                                   </span>
                                   <span>
                                       <span>成立日期:</span>
                                       <span>{{item._source.create_date}}</span>
                                   </span>
                               </section>
                               <section class="cz">
                                    <span>
                                        <span>企业网址:</span>
                                        <span>{{item._source.website}}</span>
                                        <span class="block"></span>
                                    </span>
                                    <span>
                                        <span>所属行业:</span>
                                        <span>{{item._source.industry}}</span>
                                        <span class="block"></span>
                                    </span>
                                </section>
                                <p><span>地址：</span>{{item._source.address}}</p>
                               <div class="tip">
                                   <span>基本信息(6)</span>
                                   <span>招聘信息(1)</span>
                                   <span>知识产权(2)</span>
                               </div>
                           </div>
                        </div>

                    </a-card>
                </div>

            </div>

            <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                <a-pagination
                show-size-changer
                :page-size-options="pageSizeOptions"
                :default-current="1"
                :total="pagination.total"
                :defaultPageSize="10"
                @change="handleTableChange"
                @showSizeChange="onShowSizeChange"
                size="small"
                >
                    <template slot="buildOptionText" slot-scope="props">
                        <span>{{ props.value }}条/页</span>
                    </template>

                </a-pagination>
            </div>

        </div>
      

    <a-drawer
      placement="right"
      :closable="false"
      :visible="visible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      width="1024"
      class="tc"
    >
      <div class="company-content">
          <section class="left">
              <div class="top-info" v-if="companydetail">
                    <div class="company-info" style="background:#fff" >
                        <div class="lq-phone">
                            <a-button type="primary" @click="receivephone(companydetail._source.id)">一键领取</a-button>
                        </div>
                        <div class="company-head">
                            <img src="../../../static/head.jpg" alt="">
                        </div>
                        <div class="info">
                            <h3>{{companydetail._source.name}} <span>{{companydetail._source.check_date}}更新</span></h3>
                            <section class="type">
                                <span>联系方式{{companydetail._source.total_contact_num}}个</span>
                                <span>{{companydetail._source.industry}}</span>
                                <span>{{companydetail._source.status}}</span>
                            </section>
                            <section class="cz">
                                <span>
                                    <span>法定代表:</span>
                                    <span>{{companydetail._source.legal}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>注册资本:</span>
                                    <span>{{companydetail._source.registermoney}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>成立日期:</span>
                                    <span>{{companydetail._source.create_date}}</span>
                                </span>
                            </section>
                            <p><span>地址：</span>{{companydetail._source.address}}</p>
                        </div>
                    </div>


                    <div class="all-info">
                        <a-tabs default-active-key="1">
                            <a-tab-pane key="1" tab="基本信息" v-if="companydetail">
                                <div class="s-menu">
                                    <span><a href="">企业简介</a></span>
                                    <span><a href="">工商信息</a></span>
                                    <span><a href="">股东信息1</a></span>
                                    <span><a href="">主要人员2</a></span>
                                    <span><a href="">工商变更2</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title"> 
                                            <span class="block"></span>
                                            <span class="font">企业简介</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="text">
                                                <span>微盟是一家专门针对微信公众账号提供营销推广服务的第三方平台，主要功能是针对微信商家公众号提供与众不同的、有针对性的营销推广服务。上海晖硕信息科技有限公司旗下产品。</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">工商信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <a-descriptions bordered :column="2">
                                                <a-descriptions-item label="统一社会信用代码">{{companydetail._source.creditcode}}</a-descriptions-item>
                                                <a-descriptions-item label="所属人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="组织机构代码">{{companydetail._source.organizationcode}}</a-descriptions-item>
                                                <a-descriptions-item label="经营状态">{{companydetail._source.status}}</a-descriptions-item>
                                                <a-descriptions-item label="法定代表人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="注册资本">{{companydetail._source.registermoney}}</a-descriptions-item>
                                                <a-descriptions-item label="公司类型">{{companydetail._source.companytype}}</a-descriptions-item>
                                                <a-descriptions-item label="成立日期">{{companydetail._source.create_date}}</a-descriptions-item>
                                                <a-descriptions-item label="营业期限">--</a-descriptions-item>
                                                <a-descriptions-item label="登记机关">--</a-descriptions-item>
                                                <a-descriptions-item label="核准日期">{{companydetail._source.check_date}}</a-descriptions-item>
                                                <a-descriptions-item label="公司规模">{{companydetail._source.insurancenum}}</a-descriptions-item>
                                                <a-descriptions-item label="纳税人识别号">{{companydetail._source.taxpayernum}}</a-descriptions-item>
                                                <a-descriptions-item label="所属行业">{{companydetail._source.industry}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="曾用名">{{companydetail._source.oldname}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="企业地址">{{companydetail._source.address}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="经营范围">{{companydetail._source.scope}}</a-descriptions-item>
                                            </a-descriptions>
                                        </div>
                                    </div>

                                   
                                </div>

                            </a-tab-pane>
                           
                        </a-tabs>

                    </div>
              </div>
        </section>
        <section class="right" v-if="companydetail">
            <div>
                <section class="company-phone-tabs">
                    <section class="phone-index-top-info">
                        <div class="company-phone-index-left">
                            <span>联系方式</span>
                            <a-popover placement="bottomRight">
                                <template slot="content">
                                    <p style="width:210px">所有信息均来自互联网公开数据，如您认为有侵犯到您的个人信息或隐私，请联系客服进行处理。</p>
                                </template>
                                <a-icon type="info-circle" />
                            </a-popover>
                        </div>
                    </section>
                    <a-divider />
                    <section class="phone-index-source-type">
                        <span @click="switchphone(1,companydetail._source.id)" :class="{phonetype:1==current}">手机（{{companydetail._source.total_mobile_num}}）</span>
                        <span @click="switchphone(2,companydetail._source.id)"  :class="{phonetype:2==current}">固话（{{companydetail._source.total_tel_num}}）</span>
                    </section>
                </section>
            </div>
            <div>
                <div class="phone-card-item" v-for="(item,i) in phone_list" :key="i">
                    <div class="phone-index-phone">
                        <p>{{item}}</p>
                    </div>
                    <div class="item-receive-status">
                        <a-button @click="receivephone(companydetail._source.id)">立即领取</a-button>
                    </div>
                </div>
            </div>
            
        </section>
      </div>
    </a-drawer>
    </div>
</template>

<script>
import Vue from 'vue'
import areaSelect from 'vue-area-select-lei'
Vue.use(areaSelect)
export default {
  data() {
    return {
        visible: false,
        pagination:{},
        size:10,
        currentpage:"",
        pageshow:false,
        totalpage:"",
        companylist:"",
        companydetail:"",
        phone_list:"",
        current:1,
        searchname:"",

        pageSizeOptions:['10','20','30','40','100','200'],
        city:"",
        addreslist:['北京','上海','广州','深圳','天津','杭州','南京','苏州','成都','武汉','重庆','西安','郑州'],
        currented:"",
        hy:"",
        qy:"",
        zt:"",
        zb:"",
        nx:"",

   

    };
  },
  mounted(){
    this.searchname=this.$route.query.name
    this.fetch()
  },
  methods: {
    //   选择地区
    selectaddress(value,b){
        // alert(b)
        this.currented=b
        this.city=value
        this.fetch()
    },
    // 选择行业
    onChangehx(e){
        this.hy=e.target.value
        this.fetch()
    },
    //企业类型
    onChangeqy(e){
        this.qy=e.target.value
        this.fetch()
    },
    // 注册资本
    onChangezb(e){
        this.zb=e.target.value
        this.fetch()
    },
    // 成立年限
    onChangenx(e){
        this.nx=e.target.value
        this.fetch()
    },
    // 企业状态
    onChangezt(e){
        this.zt=e.target.value
        this.fetch()
    },
    // 领取电话
    receivephone(value){
        this.$axios.get("/api/receiveqcc",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.$message.success(res.data.msg); 
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },

       //   切换
    switchphone(value,id){
        this.current=value
         this.$axios.get("/api/getqccdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.visible = true;
                this.companydetail=res.data.data
                if(value==1){
                    this.phone_list=res.data.data._source.phone_list
                }else if(value==2){
                    this.phone_list=res.data.data._source.tel_list
                }
  
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
      // 抽屉
    showDrawer(value) {
      this.$axios.get("/api/getqccdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.visible = true;
                this.companydetail=res.data.data
                this.phone_list=res.data.data._source.phone_list
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
    fetch(){
        this.$axios.post("/api/getqcclist",{
            limits: this.size,
            page:this.currentpage,
            name:this.searchname,
            city:this.city,
            industry:this.hy,
            companytype:this.qy,
            status:this.zt,
            create_date:this.nx,
            registermoney:this.zb
        },{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                const pagination = { ...this.pagination };
                pagination.total = res.data.data.count;
                pagination.pageSize=this.size
                this.companylist=res.data.data.lists
                this.pagination = pagination;
                this.totalpage=Math.ceil(res.data.data.count/this.size)
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
    onShowSizeChange(current,pageSize){
        this.size=pageSize
        // alert(pageSize)
        this.fetch();
    },
    handleTableChange(pageNumber) {
        this.currentpage=pageNumber
        this.fetch();
    },
    onSearch(value) {
        this.searchname=value
        this.fetch()
    },
    onChange(){

    },
    onClose(){
        this.visible=false
    },
    afterVisibleChange() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/toker/search.vue